module.exports = __webpack_public_path__ + "img/so-good-no-pollution.ab253090.png";